import React, { useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import { Button } from "react-bootstrap";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";



const Options = [
  { value: "1", label: "L1" },
  { value: "2", label: "L2" },
];


const CaseOfficerEvaluationForm = () => {
  const [showAcceptModal, setShowAcceptModal] = useState(false);


  const handleCombine = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
    // setPoNumber("");
  };

  return (
    <div className="self-evaluation-page">
      {/* SECTION A */}
      <div className="section-card">
        <h3 className="section-title">Section A</h3>
        <div className="evaluation-table-wrapper">
          <div className="evaluation-table">
            <div className="table-header">
              <div>1. Requirement 1 Title</div>
              <div>Documents to Upload</div>
              <div>Submission</div>
            </div>

            <div className="table-body">
              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column submission">
                <button className="upload-btn btn outline-btn">Upload</button>

                <div className="files">
                  <p>
                    <b>File Uploaded</b>
                  </p>
                  <p>
                    abc.xls <span>Delete</span>
                  </p>
                  <p>
                    def.xls <span>Delete</span>
                  </p>
                </div>
                <label>Comment</label>
                <textarea disabled placeholder=""></textarea>
              </div>
            </div>

            <div className="status-bar">
              <span>Status</span>
              <span>Approved</span>
              <span></span>
            </div>
            <div className="commant-box">
              <label>Case Officer Clarification Comments (External)</label>
              <textarea placeholder="SGBC Comments"></textarea>
            </div>
            <div className="commant-box pt-0">
              <label>Peer Reviewer/Final Approver Comments (Internal)</label>
              <textarea disabled placeholder="SGBC Comments"></textarea>
            </div>
            <div
              className="form-actions
             "
            >
              <Buttons
                buttonText="Send Clarification"
                buttonTypeClassName="success-btn yellow"
                isDisable="true"
              />
              <Buttons
                buttonText="Approve"
                buttonTypeClassName="success-btn"
                isDisable="true"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SECTION B */}

      <div className="section-card">
        <h3 className="section-title">Section B</h3>
        <div className="evaluation-table-wrapper">
          <div className="evaluation-table">
            <div className="table-header">
              <div>1. Requirement 1 Title</div>
              <div>Documents to Upload</div>
              <div>Submission</div>
            </div>
            <div className="table-body">
              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column submission">
                <button className="upload-btn btn outline-btn">Upload</button>

                <div className="files">
                  <p>
                    <b>File Uploaded</b>
                  </p>

                  <p>
                    abc.xls <span>Delete</span>
                  </p>
                  <p>
                    def.xls <span>Delete</span>
                  </p>
                </div>

                <label>Comment</label>
                <textarea disabled placeholder=""></textarea>
              </div>

              <div className="row">
                {/* BLOCK 1 */}
                <div className="form-block">
                  <div className="left">
                    <label>Label</label>
                    <label className="mt-5">Instruction</label>
                  </div>
                  <div className="right">
                    <input type="text" placeholder="Textbox" />
                    <textarea disabled placeholder="Comments"></textarea>
                  </div>
                </div>

                <div className="divider"></div>

                {/* BLOCK 2 */}
                <div className="form-block">
                  <div className="left">
                    <label>
                      Label <span className="red-star">*</span>
                    </label>
                    <label className="mt-5">Instruction</label>
                  </div>
                  <div className="right">
                    <Select
                      className="custom-checkbox-select"
                      // value={props.value}
                      // value={""} /
                      options={Options}

                    // onChange={props.onChange}
                    // onBlur={props.onBlur}
                    // options={props.options}
                    // isMulti={props.isMultiSelect}
                    // placeholder={props.placeholder}
                    // isDisabled={true}
                    />
                    <textarea disabled placeholder=""></textarea>
                  </div>
                </div>

                <div className="divider"></div>

                {/* BLOCK 3 */}
                <div className="form-block">
                  <div className="left">
                    <label>Label</label>
                    <label className="mt-5">Instruction</label>
                  </div>
                  <div className="right">
                    <Select
                      className="custom-checkbox-select"
                      placeholder="Tick Rating"
                    // value={props.value}
                    // value={""} /
                    // options={Options}

                    // onChange={props.onChange}
                    // onBlur={props.onBlur}
                    // options={props.options}
                    // isMulti={props.isMultiSelect}
                    // placeholder={props.placeholder}
                    // isDisabled={true}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="status-bar">
              <span>Status</span>
              <span>Pending Clarification</span>
            </div>
            <div className="commant-box">
              <label>Case Officer Clarification Comments (External)</label>
              <textarea placeholder="SGBC Comments"></textarea>
            </div>
            <div className="commant-box pt-0">
              <label>Peer Reviewer/Final Approver Comments (Internal)</label>
              <textarea disabled placeholder="SGBC Comments"></textarea>
            </div>
            <div
              className="form-actions
             "
            >
              <Button onClick={handleCombine} className=" btn  yellow ">Send Clarification </Button>
              <Button className="submit-btn btn outline-btn">Approve</Button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <CenterModel
        show={showAcceptModal}
        handleClose={closeAcceptModal}
        modelTitle=""
      >
        <div className="model-content">
          <h3 className="model-center-title">There are requirements pending clarification.</h3>
          <p>Send clarification email?</p>
        </div>

        <div className="model-btn-center">
          <Button className="btn btn-yes">Yes</Button>
          <Button className=" btn  btn-no ">No </Button>
        </div>

      </CenterModel>

      {/* SECTION C */}

      <div className="section-card">
        <h3 className="section-title">Section C</h3>

        <div className="rating-box">
          <h4>Section C Additional Information</h4>

          <table className="rating-table">
            <tbody>
              <tr>
                <td>1 Tick</td>
                <td>
                  <span>
                    {" "}
                    <input disabled className="change-value"></input>/ 6
                  </span>
                </td>
              </tr>
              <tr>
                <td>2 Tick</td>
                <td>
                  <span>
                    <input disabled className="change-value"></input>/ 6
                  </span>
                </td>
              </tr>
              <tr>
                <td>3 Tick</td>
                <td>
                  <span>
                    <input disabled className="change-value"></input>/ 6
                  </span>
                </td>
              </tr>
              <tr>
                <td>4 Tick</td>
                <td>
                  <span>
                    <input disabled className="change-value"></input>/ 6
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="evaluation-table-wrapper">
          <div className="evaluation-table">
            <div className="table-header">
              <div>1. Requirement 1 Title</div>
              <div>Documents to Upload</div>
              <div>Submission</div>
            </div>

            <div className="table-body">
              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column">
                <p>Title in the content</p>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur tempor, magna vel auctor ultricies, tortor nibh
                  fermentum lectus, sed eleifend orci lacus vel justo. Proin
                  suscipit lacus eu libero accumsan, nec porta lectus pulvinar.
                </p>
                <p>
                  Example of links here: Click{" "}
                  <a className="link" href="#">
                    here
                  </a>{" "}
                  to see more information
                </p>
              </div>

              <div className="column submission">
                <button className="upload-btn btn outline-btn ">Upload</button>

                <div className="files">
                  <p>
                    <b>File Uploaded</b>
                  </p>
                  <p>
                    abc.xls <span>Delete</span>
                  </p>
                  <p>
                    def.xls <span>Delete</span>
                  </p>
                </div>
                <label>Comment</label>
                <textarea disabled placeholder=""></textarea>
              </div>
            </div>

            <div className="status-bar">
              <span>Status</span>
              <span>Pending Review</span>
            </div>
            <div className="commant-box">
              <label>Case Officer Clarification Comments (External)</label>
              <textarea placeholder="SGBC Comments"></textarea>
            </div>
            <div className="commant-box pt-0">
              <label>Peer Reviewer/Final Approver Comments (Internal)</label>
              <textarea disabled placeholder="SGBC Comments"></textarea>
            </div>
            <div
              className="form-actions
             "
            >
              <button className=" btn  yellow ">Send Clarification</button>
              <button className="submit-btn btn outline-btn ">Approve</button>
            </div>
          </div>
        </div>
      </div>

      <div className="section-card">
        <div className="commant-box">
          <label>Peer Reviewer Comment</label>
          <textarea className="mt-2" disabled></textarea>
        </div>
        <div className="commant-box">
          <label>Approver Reviewer Comment</label>
          <textarea className="mt-2" disabled> </textarea>
        </div>
      </div>

      <div className="form-actions">
        <Button className="black-btn btn outline-btn ">Back</Button>
        <Button className="submit-btn btn outline-btn ">Save</Button>
        <Button className="reject  btn ">Reject</Button>
        <Button className="submit-btn btn outline-btn "> Process</Button>
      </div>
    </div>
  );
};

export default CaseOfficerEvaluationForm;
